export class SC_ServiceInstancePhase {
    static readonly NULL = 4;
    static readonly NOT_STARTED = 0;
    static readonly CREW_PICS_TAKEN = 1;
    static readonly BEFORE_PICS_TAKEN = 2;
    static readonly COMPLETE = 3;

    constructor(private phase: number = SC_ServiceInstancePhase.NULL) { }

    static fromAPI(apiValue: number): SC_ServiceInstancePhase {
        switch (apiValue) {
            case SC_ServiceInstancePhase.NOT_STARTED:
                return new SC_ServiceInstancePhase(SC_ServiceInstancePhase.NOT_STARTED);
            case SC_ServiceInstancePhase.CREW_PICS_TAKEN:
                return new SC_ServiceInstancePhase(SC_ServiceInstancePhase.CREW_PICS_TAKEN);
            case SC_ServiceInstancePhase.BEFORE_PICS_TAKEN:
                return new SC_ServiceInstancePhase(SC_ServiceInstancePhase.BEFORE_PICS_TAKEN);
            case SC_ServiceInstancePhase.COMPLETE:
                return new SC_ServiceInstancePhase(SC_ServiceInstancePhase.COMPLETE);
            default:
                return new SC_ServiceInstancePhase();
        }
    }

    is(phase: number): boolean {
        return this.phase === phase;
    }

    toAPI(): number {
        return this.phase;
    }

    clone(): SC_ServiceInstancePhase {
        return new SC_ServiceInstancePhase(this.phase);
    }

    /**
     * Merges another ServiceInstancePhase object into this one, replacing null fields
     */
    merge(other: SC_ServiceInstancePhase): SC_ServiceInstancePhase {
        if (other.phase !== SC_ServiceInstancePhase.NULL) {
            this.phase = other.phase;
        }

        return this;
    }

    static readonly phases: { key: number; display: string }[] = [
        { key: SC_ServiceInstancePhase.NULL, display: "Not Set" },
        { key: SC_ServiceInstancePhase.NOT_STARTED, display: "Not Started" },
        { key: SC_ServiceInstancePhase.CREW_PICS_TAKEN, display: "Crew Pics Taken" },
        { key: SC_ServiceInstancePhase.BEFORE_PICS_TAKEN, display: "Before Pics Taken" },
        { key: SC_ServiceInstancePhase.COMPLETE, display: "Complete" },
    ];

    toString(): string {
        switch (this.phase) {
            case SC_ServiceInstancePhase.CREW_PICS_TAKEN:
                return "Crew Pics Taken";
            case SC_ServiceInstancePhase.BEFORE_PICS_TAKEN:
                return "Before Pics Taken";
            case SC_ServiceInstancePhase.COMPLETE:
                return "Complete";
            default:
                return "Not Set";
        }
    }

    after(other: number): boolean {
        return this.phase > other;
    }

    afterOrOn(other: number): boolean {
        return this.phase >= other;
    }
}
